const CURRENCY_SYMBOLS = {
  JPY: "¥",
  USD: "$",
  EUR: "€",
  KRW: "₩",
  THB: "฿",
  TWD: "",
};

const MINOR_UNIT_DIVISORS = {
  JPY: 1,
  KRW: 1,
  USD: 100,
  EUR: 100,
  THB: 100,
  TWD: 100,
};

export function formatPrice(price, currencyCode) {
  const divisor = MINOR_UNIT_DIVISORS[currencyCode] || 100;
  const amount = Math.floor(price / divisor).toLocaleString();

  if (currencyCode === "TWD") {
    return `${amount} 元`;
  }

  if (currencyCode === "THB") {
    return `${amount}฿`;
  }

  return `${CURRENCY_SYMBOLS[currencyCode] || ""}${amount}`;
}
